export const PhoneType = Object.freeze({
  WEB: 0,
  SIP_PHONE: 1,
  SIP_PHONE_NOT_AUTH: 2,
  PHONE: 3,
  MOBILE_APP: 5,
})

export const PhoneTypeContext = Object.freeze({
  [PhoneType.WEB]: 'Trình duyệt',
  [PhoneType.MOBILE_APP]: 'App điện thoại',
  [PhoneType.SIP_PHONE]: 'SIP Phone',
  [PhoneType.SIP_PHONE_NOT_AUTH]: 'SIP Phone (Không Login)',
  [PhoneType.PHONE]: 'Số điện thoại',
})

export const CallStatus = Object.freeze({
  ANSWERING: 'ANSWERING',
  QUEUEING: 'QUEUEING',
  RINGING: 'RINGING',
  MUTING: 'MUTING',
  HOLDING: 'HOLDING',
  DIALING: 'DIALING',
  ENDED: 'ENDED',
  FAILED: 'FAILED',
})

export const CallStatusContext = Object.freeze({
  [CallStatus.ANSWERING]: 'Đang trả lời',
  [CallStatus.QUEUEING]: 'Đang chờ',
  [CallStatus.RINGING]: 'Đang đổ chuông',
  [CallStatus.MUTING]: 'Đang tắt mic',
  [CallStatus.HOLDING]: 'Đang giữ máy',
  [CallStatus.DIALING]: 'Đang kết nối',
})

export const IsCallingStatuses = Object.freeze([
  CallStatus.ANSWERING,
  CallStatus.QUEUEING,
  CallStatus.RINGING,
  CallStatus.MUTING,
  CallStatus.HOLDING,
  CallStatus.DIALING,
])

export const CallType = Object.freeze({
  INCOMING: 'CALL_INBOUND',
  OUTGOING: 'CALL_OUTBOUND',
})

export const CallTypeContext = Object.freeze({
  [CallType.INCOMING]: 'Cuộc gọi từ',
  [CallType.OUTGOING]: 'Cuộc gọi ra',
})

export const DialCallAction = Object.freeze({
  INVITE: 'invite',
  TRANSFER: 'transfer',
  TRANSFER_TO_ACD: 'transferACD',
  TRANSFER_TO_IVR: 'transferIVR',
})
export const DialCallActionContext = Object.freeze({
  [DialCallAction.INVITE]: 'Mời chuyên viên tham gia',
  [DialCallAction.TRANSFER]: 'Chuyển tiếp cho chuyên viên',
  [DialCallAction.TRANSFER_TO_ACD]: 'Chuyển tiếp đến ACD',
  [DialCallAction.TRANSFER_TO_IVR]: 'Chuyển tiếp đến IVR',
})
